import { useEffect } from "react";

/**
 * A hook that handles arrow key navigation.
 *
 * @param {Function} onLeftArrow - Callback function for when the left arrow key is pressed.
 * @param {Function} onRightArrow - Callback function for when the right arrow key is pressed.
 * @param {Array} dependencies - Optional dependencies for the effect.
 */
const useArrowNavigation = (onLeftArrow, onRightArrow, dependencies = []) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        onRightArrow();
      } else if (event.key === "ArrowLeft") {
        onLeftArrow();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, dependencies); // Make sure to pass dependencies if the callbacks depend on any external values
};

export default useArrowNavigation;
